import { render, staticRenderFns } from "./scanCodeBox.vue?vue&type=template&id=2abaf6ae&scoped=true"
import script from "./scanCodeBox.vue?vue&type=script&lang=js"
export * from "./scanCodeBox.vue?vue&type=script&lang=js"
import style0 from "./scanCodeBox.vue?vue&type=style&index=0&id=2abaf6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abaf6ae",
  null
  
)

export default component.exports